import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { LocalizedText, withScopeContext } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { areAllBillOrderItemsSelected } from '../../ducks/billItems';

interface StateProps {
    allSelected: boolean;
}
interface OwnProps {
    billId: string;
    scope: string;
}

const RebateSelectAllItemsLabel = ({ allSelected }: StateProps) => (
    <LocalizedText textKey={allSelected ? TextKey.DeselectAll : TextKey.SelectAll} />
);

export default withScopeContext(
    pipe(
        RebateSelectAllItemsLabel,
        connect<StateProps, {}, OwnProps, ApplicationState>(
            createStructuredSelector({
                allSelected: areAllBillOrderItemsSelected,
            })
        )
    )
);
